module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-forgot-password"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.forgot_password.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-forgot-password__main"
  }, [(!_vm.email_sent) ? _c('section', {
    staticClass: "c-card"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.email_label')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card__p"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.email_hint')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.primary_email),
      expression: "request.primary_email"
    }],
    class: {
      'is-not-valid': _vm.errors.primary_email
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('web.forgot_password.email_placeholder'),
      "required": ""
    },
    domProps: {
      "value": (_vm.request.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "primary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.primary_email) ? _c('div', {
    staticClass: "c-validation t-alert-danger",
    attrs: {
      "for": "primary_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errors.primary_email[0]) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('router-link', {
    staticClass: "c-card__footer__text-link u-tiny-note u-float-left t-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.forgot_password.back_to_login')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button u-float-right t-button-primary",
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.forgot_password.send_button')) + "\n          ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.email_sent) ? _c('section', {
    staticClass: "c-card"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('h2', {
    staticClass: "u-h4"
  }, [_vm._v(_vm._s(_vm.$t('web.forgot_password.success_message')))]), _vm._v(" "), _c('p', {
    staticClass: "c-card__p"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.forgot_password.success_message_details')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('i18n', {
    staticClass: "u-tiny-note",
    attrs: {
      "path": "web.forgot_password.success_goto_login",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "login_link",
      fn: function() {
        return [_c('router-link', {
          staticClass: "c-card__footer__text-link u-back-page t-link",
          attrs: {
            "to": {
              name: 'Login'
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$t('web.forgot_password.success_goto_login_link')) + "\n            ")])]
      },
      proxy: true
    }], null, false, 2874701027)
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98201964"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgotPassword.vue
// module id = 560
// module chunks = 1